import { SearchEngine } from '@coveo/headless';
import { buildSitesHeadlessEngine } from './sitesHeadlessEngineConfiguration';

// eslint-disable-next-line @typescript-eslint/ban-types
const sitesHeadlessEngine: SearchEngine<{}> = buildSitesHeadlessEngine();

export default sitesHeadlessEngine;
